import { cssInterop } from "nativewind";
import React from "react";
import {
  Carousel as RNCarousel,
  CarouselProps,
  CarouselRef,
  Pagination,
} from "react-native-reanimated-carousel";

// v5 swapped the meaning of `style` and `contentContainerStyle` relative to
// v4's `style` (content) / `containerStyle` (outer wrapper): the outer view
// is now styled via `style`, and the per-item content via
// `contentContainerStyle`. Keep `className` mapped to the content and
// `containerClassName` mapped to the outer wrapper, matching v4 behavior.
export const Carousel = cssInterop(RNCarousel, {
  className: "contentContainerStyle",
  containerClassName: "style",
}) as <T>(
  props: React.PropsWithChildren<CarouselProps<T>> & {
    className?: string;
    containerClassName?: string;
    ref?: React.Ref<CarouselRef>;
  },
) => React.JSX.Element;

export const BasicPagination = cssInterop(Pagination, {
  activeDotClassName: "activeDotStyle",
  dotClassName: "dotStyle",
  containerClassName: "containerStyle",
});
